import { Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <>
      <section id="contact" data-testid="contact-section" className="bg-blue-800 py-16 sm:py-20">
        <div className="mx-auto flex max-w-7xl flex-col items-center gap-6 px-4 text-center sm:px-6 lg:px-8">
          <h2 className="max-w-2xl font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Have a Question Before You Dive In?
          </h2>
          <p className="max-w-xl text-base leading-relaxed text-blue-100">
            Whether it's coaching, NuCalm, or LegalShield — reach out and I'll personally point you
            in the right direction.
          </p>
          <div data-testid="contact-info" className="flex flex-col items-center gap-2.5">
            <p className="font-display text-lg font-bold text-white">John Jones</p>
            <a
              href="mailto:thisisjohnjones@gmail.com"
              data-testid="contact-email-link"
              className="inline-flex items-center gap-2 text-sm font-medium text-blue-100 transition-colors hover:text-white"
            >
              <Mail className="h-4 w-4" />
              thisisjohnjones@gmail.com
            </a>
            <a
              href="tel:+12145004192"
              data-testid="contact-phone-link"
              className="inline-flex items-center gap-2 text-sm font-medium text-blue-100 transition-colors hover:text-white"
            >
              <Phone className="h-4 w-4" />
              214-500-4192
            </a>
          </div>
        </div>
      </section>

      <footer data-testid="site-footer" className="bg-[#0B1B33] py-12 text-slate-400">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <p data-testid="footer-credentials" className="text-center font-display text-sm font-semibold text-slate-200">
            John Jones | Certified LifeWorks Life Mastery Coach · Independent LegalShield Associate ·
            NuCalm Partner
          </p>

          <div className="mx-auto mt-8 max-w-3xl space-y-2 border-t border-white/10 pt-8 text-center text-xs leading-relaxed">
            <p data-testid="footer-compliance-line">
              LifeWorks, NuCalm, and LegalShield are separate companies. Products are offered
              independently.
            </p>
            <p data-testid="footer-email-consent">
              By submitting your email, you consent to receive periodic emails from John Jones with
              strategies and updates on energy, focus, sleep, and intentional living. You may
              unsubscribe at any time.
            </p>
            <p className="pt-4 text-slate-500">© 2026 nowlifeworks.com. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </>
  );
}
